import api from '@/api/login'

const state = {
  token: '',
  status: 'disconnected',
  info: {
    /*
      id,
      name,
      firstName,
      email
    */
  }
}

// getters
const getters = {
  isSessionExpired: state => {
    return state.status === 'expired'
  },

  loginState: state => {
    const logged = state.status === 'connected'
    const info = logged && state.info != null && state.info.roles != null
    const admin = info && state.info.roles.indexOf('admin') !== -1
    const user = info && state.info.roles.indexOf('user') !== -1
    const medical = info && state.info.roles.indexOf('medical') !== -1
    const cpias = info && state.info.roles.findIndex(
      r => r.startsWith('cpias:')
    ) !== -1
    return {
      isLoggedIn: logged,
      isAdmin: admin,
      isUser: user,
      isMedical: medical,
      isCpias: cpias
    }
  },

  completeName: state => {
    return `${state.info.firstName} ${state.info.name}`
  },

  region: state => {
    if (state.status !== 'connected' || state.info == null) {
      return null
    }

    const cpias = state.info.roles.find(r => r.startsWith('cpias:'))
    if (cpias == null) {
      return null
    }

    return cpias.slice(6)
  },

  token: state => {
    return state.status === 'connected' ? state.token : ''
  }
}

// actions
const actions = {
  login ({ commit }, request) {
    commit('setStatus', 'connecting')
    return api.login(request.email, request.password).then((response) => {
      if ((response.data.err == null) && (response.data.t != null)) {
        commit('setStatus', 'connected')
        commit('setToken', response.data.t)
        commit('setInfo', response.data.u)
      }
      return response
    })
  },

  logout ({ commit }, reason) {
    commit('logout')
    commit('setStatus', reason)
  }
}

// mutations
const mutations = {
  setStatus (state, status) {
    state.status = status
  },

  setToken (state, token) {
    state.token = token
  },

  setInfo (state, info) {
    state.info = info
  },

  logout (state) {
    state.token = ''
    state.info = {}
    state.all = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
